export enum BookingFailureStatus {
  Running = 'RUNNING',
  Scheduled = 'SCHEDULED',
  Success = 'SUCCESS',
  Failed = 'FAILED'
}
